import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function constructSearchParamsFromObject(obj) {
  let searchStr = "";

  Object.keys(obj).forEach((key) => {
    if (obj[key] !== undefined && obj[key] !== null && obj[key] !== "") {
      searchStr += `${searchStr ? "&" : "?"}${key}=${encodeURIComponent(
        obj[key]
      )}`;
    }
  });

  return searchStr;
}

export function roundToTwoDecimalPlaces(num) {
  return Math.round(num * 100) / 100;
}
